import React, { useEffect } from 'react';
import { Trans, t } from '@lingui/macro';

import ExternalLink from '~/app/shared/components/ExternalLink';
import SignupForm from '../../SignupForm';
import TimelineItem from './TimelineItem';
import {
    DIALOG_OPEN,
    DIALOG_OPEN_MIXPANEL,
    trackSmartPayOnboardingMixpanel,
    trackSmartPayOnboarding,
} from '../../../../../tracking/tracking';

const Overview = ({ closeDialog }) => {
    useEffect(() => {
        trackSmartPayOnboardingMixpanel(DIALOG_OPEN_MIXPANEL);

        const isFromMarket = window.location.hash === '#onboardSmartPay';
        trackSmartPayOnboarding(DIALOG_OPEN, { Source: isFromMarket ? 'Market' : 'SmartPayPage' });
    }, []);

    const timelineItems = [
        {
            title: t`Fill in information about you and your company`,
            time: t`2 min`,
        },
        {
            title: t`Create the November First account with our partner November First`,
            time: t`1 min`,
        },
        {
            title: t`Specify expected use of Smart Pay and ID verification`,
            desc: t`ID verification applies to persons with a minimum of 25% ownership of the company - you can upload the ID yourself or send a digital request for this to the relevant persons during the setup.`,
            time: t`10 min`,
        },
        {
            title: t`Sign OS agreement`,
            desc: t`Mastercard Transfer Service (OS) for automatic payment from the company's account`,
            time: t`2 min`,
        },
        {
            title: t`Wait for account validation - November First validates your account`,
            time: t`1-7 days`,
        },
    ];

    return (
        <SignupForm onBack={closeDialog}>
            <div className="my-3">
                <Trans>
                    Smart Pay is offered in collaboration with the Danish payment institution November First. In order for you to
                    use the function, November First must first verify your identity through a KYC (Know Your Customer) process.
                </Trans>
            </div>
            <div className="font-bold text-base">
                <Trans>When setting up Smart Pay, you must go through 5 steps:</Trans>
            </div>
            <div className="bg-grey-100 rounded-lg p-4 my-3">
                {timelineItems.map((item, index) => (
                    <TimelineItem key={item.title} index={index + 1} isLast={timelineItems.length === index + 1} {...item} />
                ))}
            </div>

            <div>
                <Trans>
                    Do you have questions about setting up Smart Pay?{' '}
                    <ExternalLink href="https://www.e-conomic.dk/funktioner/smartpay/kom-i-gang">Let us contact you</ExternalLink>
                </Trans>
            </div>
        </SignupForm>
    );
};

export default Overview;
